import {
  LibraryManagementState,
  LibraryManagementActionTypes,
  LibraryManagementActionNames,
} from './types';

const initialState: LibraryManagementState = {
  softwareFiles: [],
  communicatorFiles: [],
  standardParameterConfig: [],
  vimsShaValue: '',
  rtdsShaValue: '',
  vimsRtdsTableData: [],
};

export const softwareLibraryManagementReducer = (
  state: LibraryManagementState = initialState,
  action: LibraryManagementActionTypes,
): LibraryManagementState => {
  switch (action.type) {
    case LibraryManagementActionNames.SET_SOFTWARE_FILES: {
      return {
        ...state,
        softwareFiles: action.payload,
      };
    }
    case LibraryManagementActionNames.SET_COMMUNICATOR_FILES: {
      return {
        ...state,
        communicatorFiles: action.payload,
      };
    }
    case LibraryManagementActionNames.SET_STANDARD_PARAMETER_CONFIG_FILES: {
      return {
        ...state,
        standardParameterConfig: action.payload,
      };
    }
    case LibraryManagementActionNames.SET_VIMS_FILE_EXISTS: {
        return {
          ...state,
          vimsShaValue: action.payload,
        };
    }
    case LibraryManagementActionNames.SET_VIMS_RTDS_TABLE_DATA: {
        return {
          ...state,
          vimsRtdsTableData: action.payload,
        };
    }
    case LibraryManagementActionNames.SET_RTDS_FILE_EXISTS: {
      return {
        ...state,
        rtdsShaValue: action.payload,
      };
  }
    default:
      return state;
  }
};